import { useMutation } from '@tanstack/react-query';
import { getPresignedUrlToUpload } from '../../../../shared/service/selfService';
import { MutationCallbacks } from '../../../../shared/types/mutation';
import { RosterFileUploadResponse } from '../types';

export default function useGetPresignedUrl({
  onSuccess,
  onError,
}: MutationCallbacks) {
  return useMutation<void, unknown, File, RosterFileUploadResponse>({
    mutationFn: async (file: File) => getPresignedUrlToUpload(file),
    onSuccess,
    onError,
  });
}
